import { Component, OnInit, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {RideReason} from "../../../../enums/ride-reason";

@Component({
  selector: 'app-ride-reason',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule
],
  templateUrl: './ride-reason.component.html',
  styleUrl: './ride-reason.component.css'
})
export class RideReasonComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: string }[] = [];
  radioControl = new FormControl();

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.rideReasonOptionHeadline1,
        caption: this.locale.currentTranslation.rideReasonOptionCaption1,
        value: RideReason.PrivateTrip
      },
      {
        headline: this.locale.currentTranslation.rideReasonOptionHeadline2,
        caption: this.locale.currentTranslation.rideReasonOptionCaption2,
        value: RideReason.Commute
      },
      {
        headline: this.locale.currentTranslation.rideReasonOptionHeadline3,
        caption: this.locale.currentTranslation.rideReasonOptionCaption3,
        value: RideReason.BusinessTrip
      },
    ]
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.rideReason) {
        this.radioControl = new FormControl(this.claimService.claimReport().rideReason);
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({rideReason: this.radioControl.getRawValue()});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['ride-reason']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue == null;
  }

  setOption(value: string) {
    this.radioControl.patchValue(value);
    this.showError = false
  }
}
